export default "__VITE_ASSET__Bs90jWKO__"